import { useQuery } from '@tanstack/react-query';
import * as reportsApi from '@/services/reports-api';

export function useReports() {
  return useQuery({
    queryKey: ['reports', 'bundle'],
    queryFn: reportsApi.fetchReports,
    staleTime: 60_000,
  });
}
